import { defaultStore } from '../library/firebase'
import { getService } from './service'

export const saved = async (serviceId, uid) => {
  // If has a same data, doesn't save.
  const check = await checkSaved(serviceId, uid)
  console.log('check', check)
  if (check.length > 0) {
    return new Promise(resolve => {
      console.log('delete saved')
      check.map(v => {
        console.log('map: check', v)
        defaultStore
          .collection('saved_lists')
          .doc(v)
          .delete()
          .then(() => {
            resolve('unSaved')
            console.log('Document successfully deleted!')
          })
          .catch(error => {
            resolve('unSaved fails')
            console.error('Error removing document: ', error)
          })
      })
    })
  } else {
    return getService(serviceId).then(service => {
      const saved = Object.assign(service, {
        saveUid: uid,
        serviceId: serviceId
      })
      return new Promise(resolve => {
        defaultStore
          .collection('saved_lists')
          .add(saved)
          .then(data => {
            console.log('saved_lists', data)
            resolve('Saved')
          })
      })
    })
  }
}

export const getSaveLists = uid => {
  return new Promise(resolve => {
    defaultStore
      .collection('saved_lists')
      .where('saveUid', '==', uid)
      .get()
      .then(snap => {
        const result = []
        snap.forEach(doc => {
          result.push(Object.assign({ id: doc.id }, doc.data()))
        })
        resolve(result)
      })
  })
}

export const checkSaved = (serviceId, uid) => {
  return new Promise(resolve => {
    let result = []
    defaultStore
      .collection('saved_lists')
      .where('saveUid', '==', uid)
      .where('serviceId', '==', serviceId)
      .get()
      .then(snap => {
        // console.log('check snap', snap)
        snap.forEach(v => {
          result.push(v.id)
        })
        resolve(result)
      })
  })
}

export const unSaved = (serviceId, uid) => {
  return new Promise(resolve => {
    if (checkSaved(serviceId, uid)) {
      defaultStore
        .collection('saved_lists')
        .where('saveUid', '==', uid)
        .where('serviceId', '==', serviceId)
        .delete()
        .then(() => {
          resolve(true)
          console.log('Document successfully deleted!')
        })
        .catch(error => {
          resolve(false)
          console.error('Error removing document: ', error)
        })
    }
  })
}
